import React, { useState, useEffect, useCallback } from 'react';
import { useParams, useLocation  } from 'react-router-dom';
import TextField from '@mui/material/TextField';
import Select from '@mui/material/Select';
import MenuItem from '@mui/material/MenuItem';
import FormControl from '@mui/material/FormControl';
import InputLabel from '@mui/material/InputLabel';
import axios from 'axios';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faTrash,faComment, faChartSimple} from '@fortawesome/free-solid-svg-icons';
import GanttView from './GanttView'; 
import { Input, InputAdornment} from '@mui/material';
import TaskTimerAction from '../UserComponents/TaskTimerAction';
import SlideTask from '../UserComponents/SlideTask';



const Taskboard = () => {
      const { projectId } = useParams();
      const location = useLocation();
      const queryParams = new URLSearchParams(location.search);
      const user = queryParams.get('user');
      const [taskData, setTaskData] = useState([]);
      const [newTask, setNewTask] = useState({});
      const [users, setUsers] = useState([]);
      const [showForm, setShowForm] = useState(false);
      const [showGantt, setShowGantt] = useState(false);
      const [activeCommentTaskId, setActiveCommentTaskId] = useState(null);
      const [showSidebar, setShowSidebar] = useState(false);
      const [selectedRowData, setSelectedRowData] = useState(null);
      const [searchText, setSearchText] = useState('');
      const [priorityFilter, setPriorityFilter] = useState('');
      const [userFilter, setUserFilter] = useState('');
      const [currentUser, setCurrentUser] = useState(null);
      const [projectName, setProjectName] = useState('');

      useEffect(() => {
        const fetchUserData = async () => {
          // Try admin first
          try {
            const adminRes = await axios.get('/api/login.php?action=dashboard', {
              withCredentials: true,
            });
            if (adminRes.data?.admin) {
              setCurrentUser(adminRes.data.admin);
              return;
            }
          } catch (err) {
            // Only log error if it's not 401
            if (err.response?.status !== 401) {
              console.error("Admin fetch failed:", err);
            }
          }
       // Fallback to user
          try {
            const userRes = await axios.get('/api/mainuser.php?action=dashboard', {
              withCredentials: true,
            });
      
            if (userRes.data?.user) {
              setCurrentUser(userRes.data.user);
              return;
            }
          } catch (err) {
            if (err.response?.status !== 401) {
              console.error("User fetch failed:", err);
            }
            window.location.href = '/login';
          }
        };
        fetchUserData();
      }, []);

       useEffect(() => {
    if (projectId) {
      fetch(`/api/projectname.php?method=getById&project_id=${projectId}`)
        .then(res => res.json())
        .then(response => {
          if (response.success && response.project) {
            setProjectName(response.project.name);
          } else {
            setProjectName('Project not found');
          }
        })
        .catch(error => {
          console.error('Failed to fetch project name:', error);
          setProjectName('Error fetching name');
        });
    }
  }, [projectId]);

      useEffect(() => {
        axios.get('/api/users.php')
          .then(res => setUsers(res.data))
          .catch(err => console.error('Error fetching users:', err));
      }, []);

      useEffect(() => {
        const fetchTasksAndUpdateProject = async () => {
          try {
            const queryParams = new URLSearchParams();
            queryParams.append("project_id", projectId);
            if (user) {
              queryParams.append("user", user);
            }
            const res = await axios.get(`/api/tasks.php?${queryParams.toString()}`);
            const tasks = res.data;
            setTaskData(tasks);
            const assignToList = tasks.map(t => t.assign_to).filter(Boolean);
            await axios.put(
              `/api/update-members.php?project_id=${projectId}`,
              { team_members: assignToList },
              {
                headers: {
                  'Content-Type': 'application/json',
                },
              }
            );
          } catch (err) {
            console.error('Error loading tasks or updating project:', err);
          }
        };
        if (projectId) {
          fetchTasksAndUpdateProject();
        }
      }, [projectId, user]); // ✅ add `user` here

      const handleInputChange = (field, value) => {
        setNewTask(prev => ({
          ...prev,
          [field]: value
        }));
      };

  const handleAddTask = async () => {
    if (!newTask.name) return;

    const isUnassigned = !newTask.assigned || newTask.assigned.trim() === '';

    try {
      // Get count of existing tasks for this project
      const countRes = await axios.get(`/api/tasks.php?project_id=${projectId}`);
      const taskCount = Array.isArray(countRes.data) ? countRes.data.length : 0;

      // Extract number from projectId (e.g., PR1 → 1)
      const projectNum = projectId.replace(/[^\d]/g, '');

      const newTaskObj = {
        task_id: `TSK${taskCount + 1}P${projectNum}`,
        task_name: newTask.name,
        assign_to: newTask.assigned,
        assign_by: currentUser?.name,
        comment: newTask.comment,
        status: isUnassigned ? 'Hold' : (newTask.status || 'To Do'),
        priority: newTask.priority,
        due_date: newTask.dueDate,
        submission_date: newTask.SubmissionDate,
        start_date: newTask.StartDate,
        project_id: projectId,
      };
      const res = await axios.post('/api/tasks.php', newTaskObj);
      const dbId = res.data.id;
      setTaskData(prev => [...prev, { ...newTaskObj, id: dbId }]);
      setNewTask({});
      setShowForm(false);
      window.location.reload();
    } catch (err) {
      console.error('Error adding task:', err);
    }
  };


  const updateTask = (id, updatedFields) => {
  const task = taskData.find(t => t.id === id);
  const updatedTask = { ...task, ...updatedFields };

  // 👉 Apply rule: If assign_to is not empty AND current status is "Hold", change to "To Do"
  if (
    updatedTask.assign_to &&
    updatedTask.assign_to.trim() !== '' &&
    task.status === 'Hold'
  ) {
    updatedTask.status = 'To Do';
  }

  setTaskData(prev => prev.map(t => (t.id === id ? updatedTask : t)));

  axios.put(`/api/tasks.php?id=${id}`, {
    task_name: updatedTask.task_name,
    assign_to: updatedTask.assign_to,
    comment: updatedTask.comment,
    status: updatedTask.status,
    priority: updatedTask.priority,
    start_date: updatedTask.start_date,
    due_date: updatedTask.due_date,
    submission_date: updatedTask.submission_date,
  }).catch(err => console.error('Error updating task:', err));
};



    const deleteTask = (id) => {
      if (window.confirm('Are you sure you want to delete this task?')) {
        axios.delete(`/api/tasks.php?id=${id}`)
          .then(() => {
            setTaskData(prev => prev.filter(task => task.id !== id));
          })
          .catch(err => console.error('Error deleting task:', err));
      }
    };



        const updateDuration = useCallback((taskId, newTimeObj) => {
          const task = taskData.find(t => t.id === taskId);
          let sessionArray = [];
        
          try {
            const parsed = JSON.parse(task?.duration || '[]');
            sessionArray = Array.isArray(parsed) ? parsed : [];
          } catch {
            sessionArray = [];
          }
  
          const lastSession = sessionArray[sessionArray.length - 1];
          let updatedSessions = [...sessionArray];
        
          // If trying to add a new "start"
          if (newTimeObj.start) {
            if (!lastSession || (lastSession.start && (lastSession.pause || lastSession.end))) {
              // Only add new start if no session or last session is finished
              updatedSessions.push({ start: newTimeObj.start });
            } else {
              console.warn("Cannot add new 'start': last session still running");
              return;
            }
          }
  
          else if (newTimeObj.pause || newTimeObj.end) {
            if (lastSession && lastSession.start && !lastSession.pause && !lastSession.end) {
              // Update the last active session with pause or end
              updatedSessions[updatedSessions.length - 1] = {
                ...lastSession,
                ...newTimeObj,
              };
            } else if (newTimeObj.pause && lastSession && lastSession.pause) {
              // If trying to pause again after a pause, treat it as new start
              updatedSessions.push({ start: newTimeObj.pause });
            } else {
              console.warn("Cannot add 'pause' or 'end': no active session with 'start'");
              return;
            }
          }
  
          // Save updated duration to DB
          fetch("/api/taskduration.php", {
            method: "POST",
            headers: {
              "Content-Type": "application/json",
            },
            body: JSON.stringify({
              method: "updateDuration",
              id: taskId,
              duration: JSON.stringify(updatedSessions),
            }),
          })
            .then(res => res.json())
            .then(response => {
              if (response.success) {
                console.log("Duration updated");
        
                // Update local state
                setTaskData(prev =>
                  prev.map(task =>
                    task.id === taskId ? { ...task, duration: JSON.stringify(updatedSessions) } : task
                  )
                );
              } else {
                console.error("Update failed:", response.message);
              }
            })
            .catch(error => console.error("Error updating duration:", error));
        }, [taskData]);
  
 
  
      const handleStart = useCallback((task) => {
  const now = new Date().toISOString();

  // Check if another task assigned to the same user is already running
  const runningTask = taskData.find(t => {
    if (t.assign_to !== task.assign_to || t.id === task.id) return false;
    try {
      const sessions = JSON.parse(t.duration || '[]');
      const last = sessions[sessions.length - 1];
      return last && last.start && !last.pause && !last.end;
    } catch {
      return false;
    }
  });

  if (runningTask) {
    alert(`User "${task.assign_to}" already has a running task. Pause or end that first.`);
    return;
  }

  updateDuration(task.id, { start: now });
}, [taskData, updateDuration]);

const handlePause = useCallback((task) => {
  const now = new Date().toISOString();

  const sessions = (() => {
    try {
      return JSON.parse(task.duration || '[]');
    } catch {
      return [];
    }
  })();

  const last = sessions[sessions.length - 1];

  const isResuming = last && last.start && last.pause && !last.end;

  if (isResuming) {
    // Check if another task for the same user is running
    const runningTask = taskData.find(t => {
      if (t.assign_to !== task.assign_to || t.id === task.id) return false;
      try {
        const s = JSON.parse(t.duration || '[]');
        const l = s[s.length - 1];
        return l && l.start && !l.pause && !l.end;
      } catch {
        return false;
      }
    });

    if (runningTask) {
      alert(`User "${task.assign_to}" already has a running task. Pause or end that first.`);
      return;
    }

    // Resume by starting new session
    updateDuration(task.id, { start: now });
    return;
  }

  // Pause normally
  updateDuration(task.id, { pause: now });

}, [taskData, updateDuration]);


  
  
        const handleEnd = useCallback((task) => {
  const now = new Date().toISOString();
  updateDuration(task.id, { end: now });
}, [updateDuration]);
  
 


  return (
    <div>
      <h1 className="text-[18px] font-bold mt-6 ml-8"> {projectId}: {projectName}</h1>

      <div className="max-w-full mx-auto p-8 space-y-6 pt-5">
        <div className="flex justify-between mb-2">
            
            <div className="flex flex-wrap items-center justify-between mb-1 gap-4">
              <button className="flex items-center">
              <span className="text-lg font-semibold text-gray-800">
                Tasks: {taskData.length}
              </span>
            </button>
                {/* Search */}
                <input
                  type="text"
                  placeholder="Search Task..."
                  className="border border-gray-300 px-3 py-1 text-sm rounded-md w-64"
                  value={searchText}
                  onChange={(e) => setSearchText(e.target.value)}
                />

                {/* Priority Filter */}
                <select
                  className="border border-gray-300 px-3 py-1 text-sm rounded-md"
                  value={priorityFilter}
                  onChange={(e) => setPriorityFilter(e.target.value)}
                >
                  <option value="">All Priorities</option>
                  <option value="Urgent">Urgent</option>
                  <option value="Medium">Medium</option>
                </select>

              {/* User Filter */}
              <select
                className="border border-gray-300 px-3 py-1 text-sm rounded-md"
                value={userFilter}
                onChange={(e) => setUserFilter(e.target.value)}
              >
                <option value="">All Users</option>
                {users.map((user) => (
                  <option key={user.id} value={user.name}>
                    {user.name}
                  </option>
                ))}
              </select>
            </div>
            <div>
               <button
                        onClick={() => {
                          setShowGantt(true);              // open modal
                        }}
                        className='p-2 py-1 shadow-xl hover:bg-white hover:text-gray-700 mr-3 rounded-sm bg-gray-700 text-white'
                      >
                        <FontAwesomeIcon icon={faChartSimple} />
                      </button>
            <button className="text-gray-800 px-3 py-1 pt-0 rounded  text-sm shadow-xl hover:bg-gray-700 hover:text-white"
                onClick={() => setShowForm(!showForm)}
            >
              <span className='text-red-500 text-xl font-semibold'>+</span> Add Task
            </button>
            </div>
           
        </div>
        

        <div className="bg-white border border-gray-200 mb-20 shadow-xl ">
          <table className="min-w-full text-sm text-left text-gray-700 ">
            <thead className="bg-gray-700 text-white  text-xs uppercase">
              <tr>
                <th className="px-4 py-3 whitespace-nowrap font-medium">Task ID</th>
                <th className="px-4 py-3 whitespace-nowrap font-medium">Task Name</th>
                <th className="px-4 py-3 whitespace-nowrap font-medium">Assign To</th>
                <th className="px-4 py-3 whitespace-nowrap font-medium">Priority</th>
                <th className="px-4 py-3 whitespace-nowrap font-medium">Start Date</th>
                <th className="px-4 py-3 whitespace-nowrap font-medium">Tentative Time</th>
                <th className="px-4 py-3 whitespace-nowrap font-medium">Submission Date</th>
                <th className="px-4 py-3 whitespace-nowrap font-medium">Action</th>
                <th></th>
                <th></th>
                <th></th>
              </tr>
            </thead>
            <tbody>

              {taskData
              .filter(task => {
                const matchesSearch = task.task_name.toLowerCase().includes(searchText.toLowerCase());
                const matchesPriority = priorityFilter ? task.priority === priorityFilter : true;
                const matchesUser = userFilter ? task.assign_to === userFilter : true;
                return matchesSearch && matchesPriority && matchesUser;
              })
              .map((task) => (
                
                <tr key={task.id} className="border-b border-b-gray-300  hover:bg-gray-50">
                  <td
                    className="px-4 py-2 text-blue-600 cursor-pointer hover:underline"
                    onClick={() => {
                            setSelectedRowData(task); 
                            setShowSidebar(true);
                          }}
                  >
                    {task.task_id}
                  </td>
                  
                  <td className="px-4 py-2 w-45">
  <TextField
    variant="standard"
    size="small"
    value={task.task_name}
    onChange={(e) => updateTask(task.id, { task_name: e.target.value })}
    title={task.task_name} // 👈 tooltip on hover
    InputProps={{
      disableUnderline: true,
      sx: {
        fontSize: '12px',
        '&:hover': { borderBottom: 'none' },
        '&.Mui-focused': { borderBottom: 'none' },
      },
    }}
  />
</td>

                  <td className="px-4 py-2 flex">
                    <FormControl variant="standard" size="small" sx={{ minWidth: 140 }}>
                      <Select
                        value={task.assign_to}
                        onChange={(e) => updateTask(task.id, { assign_to: e.target.value })}
                        disableUnderline
                              sx={{
                                fontSize: '12px',
                                '&:hover': { borderBottom: 'none' },
                                '&.Mui-focused': { borderBottom: 'none' },
                              }}
                      >
                        {users.map((user) => (
                          <MenuItem key={user.id} value={user.name}>
                            {user.name}
                          </MenuItem>
                        ))}
                      </Select>
                    </FormControl>
                     {(() => {
                    let commentArray = [];
                    try {
                      commentArray = JSON.parse(task.comment);
                    } catch (e) {
                      commentArray = [];
                    }
                    const commentCount = Array.isArray(commentArray) ? commentArray.length : 0;
                    return (
                      <div className="w-0 ml-3">
                  
                    <button onClick={() => setActiveCommentTaskId(task.task_id)} className="relative">
                      <FontAwesomeIcon icon={faComment} />
                      {commentCount > 0 && (
                        <span className="absolute bottom-3 left-3 bg-gray-600 text-white rounded-full text-[0.5rem] px-1 ">
                          {commentCount}
                        </span>
                      )}
                    </button>
                    
                  {activeCommentTaskId === task.task_id && (
                  ''
                  )}
                  </div>
                    );
                  })()}
                  </td>
                  <td className="px-4 py-2 ">
                    <FormControl variant="standard" size="small" sx={{ minWidth: 100 }}>
                      <Select
                        value={task.priority}
                        onChange={(e) => updateTask(task.id, { priority: e.target.value })}
                        disableUnderline
                        IconComponent={null} 
                        sx={{
        fontSize: '12px',
        textAlign: 'center',
        borderRadius: '10px',
        paddingTop: '5px',
        paddingLeft: '20px',
        backgroundColor:
          task.priority === "Medium"
            ? "#d1fae5"
            : task.priority === "Urgent"
            ? "#f87171"
            : "transparent",
        color: task.priority === "Urgent" ? "white" : "inherit",
        '&:hover': { borderBottom: 'none' },
        '&.Mui-focused': { borderBottom: 'none' },
      }}
      MenuProps={{
        PaperProps: {
          sx: {
            borderRadius: 2,
            
            boxShadow: 'none',
            backgroundColor: 'white',
          },
        },
      }}
                        
                      >
                        <MenuItem
        value="Medium"
        sx={{
          fontSize: '11px',
          backgroundColor: '#d1fae5',
          borderRadius: '10px',
          my: 0.5,
        }}
      >
        Medium
      </MenuItem>
      
      <MenuItem
        value="Urgent"
        sx={{
          fontSize: '11px',
          backgroundColor: '#f87171',
          color: 'white',
          borderRadius: '10px',
          my: 0.5,
        }}
      >
        Urgent
      </MenuItem>
                      </Select>
                    </FormControl>
                  </td>
                   <td className="px-4 py-2">
                    <TextField
                      variant="standard"
                      type="date"
                      size="small"
                      value={task.start_date?.includes('T') ? task.start_date.slice(0, 10) : task.start_date}
                      onChange={(e) => updateTask(task.id, { start_date: e.target.value })}
                      InputProps={{ disableUnderline: true,
                        sx: {
                                fontSize: '11px',
                                '&:hover': { borderBottom: '1px solid lightgray' },
                                '&.Mui-focused': { borderBottom: '1px solid #1976d2' },
                              },
                       }}
                    />
                    
                  </td>
                  <td className="text-center">
  <FormControl variant="standard" sx={{ maxWidth: 40 }}>
    <Input
      id={`submission-date-${task.id}`}
      type="text"
      value={task.submission_date}
      onChange={(e) => updateTask(task.id, { submission_date: e.target.value })}
      endAdornment={<InputAdornment position="end">hr</InputAdornment>}
      disableUnderline 
      inputProps={{
        'aria-label': 'submission-date',
        style: {
          fontSize: '11px',
          border: 'none',
          outline: 'none',
        },
      }}
      sx={{
        '&:before': { borderBottom: 'none' }, // Remove default before border
        '&:after': { borderBottom: 'none' },  // Remove focus border
        '&:hover:not(.Mui-disabled):before': { borderBottom: 'none' }, // Remove hover border
      }}
    />
  </FormControl>
</td>

                  

                  <td className="px-4 py-2">
                    <TextField
                      variant="standard"
                      type="date"
                      size="small"
                      value={task.due_date?.includes('T') ? task.due_date.slice(0, 10) : task.due_date}
                      onChange={(e) => updateTask(task.id, { due_date: e.target.value })}
                      InputProps={{ disableUnderline: true,
                        sx: {
                                fontSize: '11px',
                                '&:hover': { borderBottom: '1px solid lightgray' },
                                '&.Mui-focused': { borderBottom: '1px solid #1976d2' },
                              },
                       }}
                    />
                  </td>
                  <td>
                    <TaskTimerAction
                            task={task}
                            onStart={handleStart}
                            onPause={handlePause}
                            onEnd={handleEnd}
                          />
                  </td>
                  <td >
                      


                  </td>
                  <td></td>
                  <td className="px-4 py-2 text-right">
                    <button
                      className="text-gray-500 hover:text-black-800 text-sm"
                      onClick={() => deleteTask(task.id)}
                      color='#1e2939'
                    >
                      <FontAwesomeIcon icon={faTrash} />
                    </button>
                  </td>
                </tr>
                
              )
              )
              }
              <SlideTask
          show={showSidebar}
          onClose={() => setShowSidebar(false)}
          data={selectedRowData}
        />
               {showForm && (
                <tr>
                  <td></td>
                  <td>
                    <TextField
                      variant="standard"
                      label="Task Name"
                      size="small"
                      onChange={(e) => handleInputChange("name", e.target.value)}
                      InputProps={{
                              style: {
                                fontSize: '12px', // Change this to any desired size
                              },
                            }}
                            InputLabelProps={{
                              style: {
                                fontSize: '12px', // Label font size
                              },
                            }}
                    />
                  </td>
                  <td>
                    <FormControl variant="standard" size="small" sx={{ minWidth: 130, fontSize: '12px',marginLeft: '12%' }}>
                      <InputLabel sx={{ fontSize: '13px' }}>Select User</InputLabel>
                      <Select
                        value={newTask.assigned || ""}
                        onChange={(e) => handleInputChange("assigned", e.target.value)}
                        label="Select User"
                        sx={{
                          fontSize: '12px',
                          '& .MuiSelect-icon': {
                            fontSize: '16px', // 👈 smaller dropdown arrow (default is 24px)
                          },
                        }}
                      >
                        <MenuItem value="">Select User</MenuItem>
                        {users.map((user) => (
                          <MenuItem key={user.user_id} value={user.name}>
                            {user.name}
                          </MenuItem>
                        ))}
                      </Select>
                    </FormControl>
                  </td>
                  
                  <td>
                    <FormControl variant="standard" size="small" sx={{ minWidth: 100 }}>
                      <InputLabel sx={{ fontSize: '13px' }}>Priority</InputLabel>
                      <Select
                        value={newTask.priority || ""}
                        onChange={(e) => handleInputChange("priority", e.target.value)}
                        sx={{
                          fontSize: '12px',
                          '& .MuiSelect-icon': {
                            fontSize: '16px', // 👈 smaller dropdown arrow (default is 24px)
                          },
                        }}
                      >
                        <MenuItem value="Medium">Medium</MenuItem>
                        <MenuItem value="Urgent">Urgent</MenuItem>
                      </Select>
                    </FormControl>
                  </td>
                  <td>
                    <TextField
                      variant="standard"
                      type="date"
                      label="Start Date"
                      size="small"
                      onChange={(e) => handleInputChange("StartDate", e.target.value)}
                      InputLabelProps={{
                            shrink: true,
                            style: { fontSize: '12px' }, // Label size
                          }}
                          InputProps={{
                            style: {
                              fontSize: '12px',  // Input text size
                              paddingTop: 0,     // Adjust vertical spacing if needed
                              paddingBottom: 0,
                            },
                          }}
                    />
                  </td>
                  <td>
                    <TextField
                      variant="standard"
                      type="number"
                      label="Tentative Time"
                      size="small"
                      onChange={(e) => handleInputChange("SubmissionDate", e.target.value)}
                      InputLabelProps={{
                            shrink: true,
                            style: { fontSize: '14px' }, // Label size
                          }}
                          InputProps={{
                            style: {
                              fontSize: '13px',  // Input text size
                              paddingTop: 0,     // Adjust vertical spacing if needed
                              paddingBottom: 0,
                                                            width: '90px',
                            },
                          }}
                    />
                  </td>
                  <td>
                    <TextField
                      variant="standard"
                      type="date"
                      label="Submission Date"
                      size="small"
                     
                      onChange={(e) => handleInputChange("dueDate", e.target.value)}
                      InputLabelProps={{
                            shrink: true,
                            style: { fontSize: '14px' }, // Label size
                          }}
                          InputProps={{
                            style: {
                              fontSize: '13px',  // Input text size
                              paddingTop: 0,     // Adjust vertical spacing if needed
                              paddingBottom: 0,
                            },
                          }}
                    />
                  </td>
                  <td className='text-right'>
                    <button
                      className="bg-gray-600 text-white rounded  hover:bg-blue-700 text-xs px-2 "
                      onClick={handleAddTask}
                    >
                      Add
                    </button>
                  </td>
                  <td></td>
                  <td></td>
                </tr>
              )}
            </tbody>
          </table>
        </div>
      </div>
     {showGantt && (
  <div className="fixed inset-0 z-50  bg-opacity-50 flex justify-center items-center bg-gradient-to-b backdrop-blur-sm from-blue-10 to-black">
    <div className=" rounded  max-w-7xl w-full ">
      <div className="flex justify-end items-center mb-1">
         <button
          className="text-gray-600 hover:text-red-600 text-2xl"
          onClick={() => {
            setShowGantt(false);
          }}
        >
          &times;
        </button>
      </div>

<GanttView projectId={projectId} />      

    </div>
  </div>
)}

      
    </div>
  );
};

export default Taskboard;
